import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

//
import { getInvitaions } from "../../../redux/features/user/actions";

//
import TitleBox from "../TitleBox";
import BoxLoading from "../../general/BoxLoading";
import NothingToShow from "../../general/NothingToShow";
import DesktopInvitationList from "./invitations/DesktopInvitationList";
import MobileInvitationList from "./invitations/MobileInvitationList";

function Invitation({ windowSize }) {
  const [invitationList, setInvitationList] = useState([]);
  const [loading, setLoading] = useState(false);

  /**
   * Get Invitions
   */
  const get_invitions = () => {
    // start loading
    setLoading(true);

    // request
    getInvitaions().then((res) => {
      if (res) {
        setLoading(false);
        setInvitationList(res);
      } else {
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    get_invitions();

    // eslint-disable-next-line
  }, []);

  return (
    <div className="invotation position-relative">
      <TitleBox
        title="Invitations"
        subject="Below are list of users that are signed up by your invitation"
      />

      {invitationList.length ? (
        <>
          {windowSize > 576 ? (
            <DesktopInvitationList items={invitationList} />
          ) : (
            <MobileInvitationList items={invitationList} />
          )}
        </>
      ) : (
        <NothingToShow text={loading ? "Loading..." : "Nothing to show"} />
      )}

      {loading && <BoxLoading />}
    </div>
  );
}

Invitation.propTypes = {
  windowSize: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  windowSize: state.themeReducer.windowSize,
});

export default connect(mapStateToProps)(Invitation);
